import {SimpleNumberComparator} from './SimpleNumberComparator';

class AgeComparator extends SimpleNumberComparator {
    constructor(closeThreshold: number) {
        super(closeThreshold);
    }
}

export {AgeComparator};
